export default function DineinMenuTables({
  name,
  tables,
  currentOrder,
  selectTable,
}) {
  return (
    <>
      <li className='tablesAccordionWrap__floor-item'>{name}</li>
      {tables?.map((table) => (
        <li
          className={
            (table.name === currentOrder?.tableNumber ||
              table.number === currentOrder?.tableNumber) &&
            table.floorLayoutId === currentOrder?.floorLayoutId
              ? 'tablesAccordionWrap__table-item tablesAccordionWrap__table-item--selected'
              : 'tablesAccordionWrap__table-item'
          }
          onClick={() => selectTable(table)}
          key={table.id}
        >
          {table.name || `Table ${table.number}`}
        </li>
      ))}
    </>
  );
}
